import React from 'react'
import Alert from 'react-bootstrap/Alert'
const ErrorAlert = ({children})  => {
    const errorMessage = children;
    return (
        <>
        { errorMessage &&
            <Alert variant="danger">
                {errorMessage}
            </Alert>
        }
        </>
    )
}

export default ErrorAlert
